import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import your translations

import lng1 from './locales/en/translation.json';
import lng2 from './locales/bg/translation.json';
import lng3 from './locales/sq/translation.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      lng1: {
        translation: lng1,
      },
      lng2: {
        translation: lng2,
      },
      lng3: {
        translation: lng3,
      },
    },
    detection: {
      // Order and from where user language should be detected
      order: ['localStorage', 'cookie', 'querystring', 'navigator', 'htmlTag', 'path', 'subdomain'],

      // Keys or params to lookup language from
      lookupLocalStorage: 'i18nextLng',
      lookupCookie: ['i18next', 'lang'], // Include 'lang' cookie here

      // Cache user language on
      caches: ['localStorage', 'cookie'],

      // Set to true to lower case the detected language
      lowerCaseLng: true,
    },

    fallbackLng: 'lng1',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  });

